import React, { useState } from "react";
import CardLayout from "../../../common/cardLayout/CardLayout";
import { ReactComponent as TriangleFlag } from "../../../../assets/icons/TriangleFlag.svg";
import { ReactComponent as EmptyAssessments } from "../../../../assets/images/EmptyAssessments.svg";
import { FlagLabels, NoAssessments } from "./FlaggedJournals";
import moment from "moment";
import SingleAssessmentModal from "../Assessments/SingleAssessmentModal";
import { useSelector } from "react-redux";
import {
  getTagBasedOnScore,
  getMaxScoreBasedOnAnswerGroups,
} from "../../../../util/helpers";
import { assessmentNameLookup } from "../../../../constants/constants";
import PatientLoader from "../../../common/PatientLoader";
import { useEffect } from "react";

const AssessmentTile = ({ assessmentData, assessmentName }) => {
  const [isAssessmentModalOpen, setAssessmentModalOpen] = useState(false);
  const { assessmentTypes } = useSelector((state) => state.assessment);
  //console.log("assessmentName",assessmentName)
  let thisAssessment = assessmentTypes.find(
    (element) => element.name === assessmentName,
  );
  //console.log("thisAssessment",thisAssessment)
  let maxScore = assessmentData?.total;
  let assessmentTag = assessmentData?.flag;
  if (!maxScore || !assessmentTag) {
    maxScore = getMaxScoreBasedOnAnswerGroups(
      thisAssessment?.answer_group,
      thisAssessment?.questionnaire,
    );

    assessmentTag = getTagBasedOnScore(
      assessmentData?.score,
      thisAssessment?.tag_group,
    );
  }

  return (
    <div className="container-fluid journal-entry-container">
      <SingleAssessmentModal
        modalIsOpen={isAssessmentModalOpen}
        setModalOpen={setAssessmentModalOpen}
        assessmentName={assessmentName}
        assessment={assessmentData}
        flag={assessmentTag}
      />
      <div className="d-flex" style={{ gap: "5px" }}>
        <div style={{ width: "60%" }}>
          <span
            onClick={() => {
              setAssessmentModalOpen(true);
            }}
            className="link-text"
            style={{
              display: "block",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            {assessmentNameLookup[assessmentName?.toLowerCase()] ||
              assessmentName}
          </span>
          <small className="muted-text">
            {assessmentData?.created
              ? moment(assessmentData?.created).format("MMM DD, YYYY")
              : "Not available"}
          </small>
        </div>
        <div
          style={{
            width: "20%",
            fontSize: "1.3rem",
            color: "black",
            userSelect: "none",
          }}
        >
          <span>{assessmentData?.score}</span>/
          <strong>{assessmentData?.total || maxScore || 0}</strong>
        </div>
        <div style={{ width: "30%" }}>
          <FlagLabels label={assessmentTag || "severe depression"} />
        </div>
      </div>
      {/* <div className="d-flex justify-content-center journal-entry-container">
        <hr style={{ width: "90%", backgroundColor: "rgba(171, 208, 245)" }} /> 
      </div> */}
    </div>
  );
};

const FlaggedAssessments = ({
  assessmentData,
  caregiverRecentAssessmentData,
  setAssessmentsTab,
  loading,
}) => {
  const [noData, setNoData] = useState(false);
  // const specificAssessments = [
  //   "Columbia - Patient",
  //   "C-SSRS",
  //   "GAD-7",
  //   "PHQ-A",
  //   "PHQ-9",
  //   "SCARED - Patient",
  //   "Columbia 1",
  //   "Insomnia",
  // ];
  const specificAssessments = ["C-SSRS", "GAD-7", "PHQ-9", "Insomnia"];
  const specificCaregiverAssessments = [
    "Columbia - Informant",
    "SCARED - Informant",
  ];
  useEffect(() => {
    // console.log("assessmentData in recent", assessmentData)
    if (assessmentData || caregiverRecentAssessmentData) {
      let counter = 0;
      Object.values(assessmentData).forEach((item) => {
        if (item?.length > 0) {
          counter += 1;
        }
      });
      Object.values(caregiverRecentAssessmentData).forEach((item) => {
        if (item?.length > 0) {
          counter += 1;
        }
      });
      setNoData(counter === 0);
    }
    // console.log("assessmentData",assessmentData)
    // console.log("caregiverRecentAssessmentData",caregiverRecentAssessmentData)
  }, [assessmentData, caregiverRecentAssessmentData]);
  return (
    <CardLayout
      className="col-sm-12 col-md-7 col-lg-7"
      style={{
        border: "8px solid transparent",
        boxSizing: "border-box",
        backgroundClip: "padding-box",
      }}
    >
      <div className="container-fluid p-4">
        {loading ? (
          <PatientLoader />
        ) : (
          <>
            <div className="d-flex justify-content-between mb-4 mt-2">
              <label
                style={{ fontSize: "1.3rem", display: "flex", gap: "10px" }}
              >
                {/* <TriangleFlag /> Flagged Assessments */}
                Recent Assessments
              </label>
              <small
                onClick={() => {
                  setAssessmentsTab();
                }}
                style={{
                  color: "#395e9d",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                View Assessments {">"}
              </small>
            </div>
            <div className="container-fluid">
              {noData ? (
                <NoAssessments
                  callback={() => {
                    setAssessmentsTab();
                  }}
                />
              ) : (
                <>
                  {/* {Object.keys(assessmentData).length > 0 &&
                    Object.keys(assessmentData)
                      .filter((assessment) => {
                        if (assessmentData[assessment].length > 0) {
                          return assessmentData;
                        }
                      })
                      .reverse()
                      .slice(0, 4)
                      .map((assessment, index) => {
                        console.log("assessmentData in",assessmentData)
                        console.log("assessmentData[assessment]",assessmentData[assessment])
                        if (assessmentData[assessment][0]) {
                          console.log("assessmentData[assessment][0]",assessmentData[assessment][0])
                        return (
                          <AssessmentTile
                            assessmentData={assessmentData[assessment][0]}
                            assessmentName={assessment}
                            key={index}
                          />
                        );}
                      })} */}
                  {Object.keys(assessmentData).length > 0 &&
                    specificAssessments
                      .filter((assessment) => {
                        return (
                          assessmentData[assessment] &&
                          assessmentData[assessment].length > 0
                        );
                      })
                      .map((assessment, index) => {
                        // console.log(assessment)
                        if (assessmentData[assessment][0]) {
                          // console.log(
                          //   "assessmentData[assessment][0]",
                          //   assessmentData[assessment][0]
                          // );
                          return (
                            <AssessmentTile
                              assessmentData={assessmentData[assessment][0]}
                              assessmentName={assessment}
                              key={index}
                            />
                          );
                        }
                      })}
                  {/* {Object.keys(caregiverRecentAssessmentData).length > 0 &&
                    Object.keys(caregiverRecentAssessmentData)
                      .filter((assessment) => {
                        if (
                          caregiverRecentAssessmentData[assessment].length > 0
                        ) {
                          return caregiverRecentAssessmentData;
                        }
                      })
                      .reverse()
                      .slice(0, 4)
                      .map((assessment, index) => {
                        if (caregiverRecentAssessmentData[assessment][0]) {
                          return (
                            <AssessmentTile
                              assessmentData={
                                caregiverRecentAssessmentData[assessment][0]
                              }
                              assessmentName={assessment}
                              key={index}
                            />
                          );
                        }
                      })} */}
                  {Object.keys(caregiverRecentAssessmentData).length > 0 &&
                    Object.keys(caregiverRecentAssessmentData)
                      .filter((assessment) =>
                        specificCaregiverAssessments.includes(assessment),
                      )
                      .map((assessment, index) => {
                        if (caregiverRecentAssessmentData[assessment][0]) {
                          return (
                            <AssessmentTile
                              assessmentData={
                                caregiverRecentAssessmentData[assessment][0]
                              }
                              assessmentName={assessment}
                              key={index}
                            />
                          );
                        }
                      })}
                </>
              )}
            </div>
          </>
        )}
      </div>
    </CardLayout>
  );
};

export default FlaggedAssessments;
